import React,{useState} from 'react'

import PropTypes from 'prop-types'
import Headerlogo from '../assets/images/headerlogo.png'

import '../styles/header.css'
import { BurgerMenuIcon, CloseIcon } from "../assets/svg";
import resume from '../assets/files/RigelJohnJamon_Resume.pdf'
const Header = (props) => {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
  };

  const closeMobileMenu = () => {
    setMobileMenuVisible(false);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    closeMobileMenu(); 
  };
  const handleDownloadResume = () => {
    // Trigger download by creating an anchor element and simulating click
    const link = document.createElement('a');
    link.href = resume;
    link.download = 'RigelJohnJamon_Resume.pdf';
    link.click();
  };
  return (
    <header
      data-role="Header"
      className={`header-header ${props.rootClassName} `}
    >
      <div className="header-container">
        <img
          alt={props.imageAlt}
          src={props.imageSrc}
          className="header-image"
        />
        <div className="header-nav">
        <span className="navigation-links-text1" onClick={() => scrollToSection("about")}>About</span>
          <span className="navigation-links-text1" onClick={() => scrollToSection("projects")}>Project</span>
          <span className="navigation-links-text1" onClick={() => scrollToSection("skills")}>Skills</span>
          <span className="navigation-links-text1" onClick={() => scrollToSection("contacts")}>Contact</span>
        </div>
      </div>
      <div className="header-btn-group">
      <button className="header-button button" onClick={handleDownloadResume}>{props.button}</button>
      </div>
      <div className="header-burger-menu" onClick={toggleMobileMenu}>
        <BurgerMenuIcon color="black" />
      </div>
      <div className={`header-mobile-menu ${mobileMenuVisible ? 'visible' : ''}`}>
        <nav className="header-nav1">
        
          <div className="header-container1">
          <div
              data-role="CloseMobileMenu"
              className="header-close-mobile-menu"
              onClick={closeMobileMenu}
            >
              <CloseIcon color="black" />
            </div>
          </div>
          <img
              alt={props.imageAlt1}
              src={props.imageSrc1}
              className="header-image1"
            />
          <span className="navigation-links-text1" onClick={() => scrollToSection("about")}>About</span>
          <span className="navigation-links-text1" onClick={() => scrollToSection("projects")}>Project</span>
          <span className="navigation-links-text1" onClick={() => scrollToSection("skills")}>Skills</span>
          <span className="navigation-links-text1" onClick={() => scrollToSection("contacts")}>Contact</span>
  
          <button className="header-button button" onClick={handleDownloadResume}>{props.button}</button>
   
        </nav>
    
      </div>
    </header>
  )
}

Header.defaultProps = {
  imageSrc:Headerlogo,
  imageAlt: 'image',
  button: 'Download Resume',
  imageSrc1: Headerlogo,
  imageAlt1: 'image',
  rootClassName: '',
}

Header.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  button: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageAlt1: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Header
